(function () {
  if (window.__pressGalleryInit) return;
  window.__pressGalleryInit = true;

  function initSection(section) {
    console.log('[press-gallery] initSection', {
      sectionId: section.dataset.sectionId,
      perPage: section.dataset.lbPerPage,
      cols: section.dataset.pgCols,
    });
    const perPage    = parseInt(section.dataset.lbPerPage, 10) || 9;
    let currentPage  = 1;
    let visiblePhotos = [];
    let rendered     = false;
    let swiperInstance = null;

    function allPhotos() {
      return Array.from(section.querySelectorAll('.lb-photo'));
    }

    function showPage(photos, page) {
      const grid = section.querySelector('[data-lb-grid]');
      const commit = () => {
        const offset  = (page - 1) * perPage;
        const pageSet = new Set(photos.slice(offset, offset + perPage));
        allPhotos().forEach(p => { p.style.display = pageSet.has(p) ? '' : 'none'; });
        const empty = section.querySelector('[data-lb-empty]');
        if (empty) empty.style.display = photos.length > 0 ? 'none' : '';
        renderPagination(photos, page);
        if (grid) grid.style.opacity = '';
      };
      if (rendered && grid) {
        grid.style.opacity = '0';
        setTimeout(commit, 180);
      } else {
        commit();
        rendered = true;
      }
    }

    function renderPagination(photos, page) {
      const bar = section.querySelector('[data-lb-pagination]');
      if (!bar) return;
      const total      = photos.length;
      const totalPages = Math.ceil(total / perPage) || 0;
      if (totalPages <= 1) { bar.innerHTML = ''; return; }
      const start = (page - 1) * perPage + 1;
      const end   = Math.min(page * perPage, total);
      bar.innerHTML =
        `<button class="lb-page-btn lb-page-btn--prev" data-lb-dir="-1"${page <= 1 ? ' disabled' : ''} aria-label="Página anterior">&#8592; Anterior</button>` +
        `<span class="lb-page-info">${start}–${end} de ${total} fotos</span>` +
        `<button class="lb-page-btn lb-page-btn--next" data-lb-dir="1"${page >= totalPages ? ' disabled' : ''} aria-label="Próxima página">Próximo &#8594;</button>`;
    }

    function navigatePage(dir) {
      const totalPages = Math.ceil(visiblePhotos.length / perPage);
      const newPage    = Math.max(1, Math.min(totalPages, currentPage + dir));
      if (newPage === currentPage) return;
      currentPage = newPage;
      showPage(visiblePhotos, currentPage);
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function openLightbox(photo) {
      const modal   = section.querySelector('[data-lb-modal]');
      const wrapper = modal.querySelector('.swiper-wrapper');
      const idx     = Math.max(0, visiblePhotos.indexOf(photo));

      if (swiperInstance) { swiperInstance.destroy(true, true); swiperInstance = null; }

      wrapper.innerHTML = visiblePhotos.map(p =>
        `<div class="swiper-slide"><img class="lb-swiper__img" src="${p.dataset.lbImg}" alt="${p.dataset.lbAlt || ''}" draggable="false" /></div>`
      ).join('');

      modal.hidden = false;
      document.body.style.overflow = 'hidden';

      requestAnimationFrame(() => {
        modal.classList.add('is-open');
        swiperInstance = new Swiper(modal.querySelector('.lb-swiper'), {
          initialSlide: idx,
          loop: visiblePhotos.length > 1,
          speed: 420,
          keyboard: { enabled: true },
          navigation: {
            nextEl: modal.querySelector('.swiper-button-next'),
            prevEl: modal.querySelector('.swiper-button-prev'),
          },
          pagination: {
            el: modal.querySelector('.swiper-pagination'),
            type: 'fraction',
          },
        });
      });
    }

    function closeLightbox() {
      const modal = section.querySelector('[data-lb-modal]');
      modal.classList.remove('is-open');
      const inst = swiperInstance;
      swiperInstance = null;
      setTimeout(() => {
        if (inst) inst.destroy(true, true);
        modal.hidden = true;
      }, 300);
      document.body.style.overflow = '';
    }

    section._lbClose = closeLightbox;

    section.addEventListener('click', e => {
      const dirBtn = e.target.closest('[data-lb-dir]');
      if (dirBtn && !dirBtn.disabled) { navigatePage(parseInt(dirBtn.dataset.lbDir, 10)); return; }
      if (e.target.closest('[data-lb-close]')) { closeLightbox(); return; }
      if (e.target.closest('[data-lb-modal]') &&
          !e.target.closest('.lb-swiper__img') &&
          !e.target.closest('.swiper-button-prev, .swiper-button-next, .swiper-pagination')) {
        closeLightbox(); return;
      }
      const photo = e.target.closest('.lb-photo');
      if (photo && photo.style.display !== 'none') { openLightbox(photo); return; }
    });

    // Initialize
    visiblePhotos = allPhotos();
    showPage(visiblePhotos, 1);
  }

  function onKey(e) {
    const modal = document.querySelector('.press-gallery [data-lb-modal].is-open');
    if (!modal) return;
    const section = modal.closest('[data-section-id]');
    if (!section) return;
    if (e.key === 'Escape') section._lbClose();
  }

  function boot() {
    document.querySelectorAll('.press-gallery').forEach(initSection);
    document.addEventListener('keydown', onKey);
    document.addEventListener('shopify:section:load', e => {
      e.target.querySelectorAll('.press-gallery').forEach(initSection);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
